import { render, staticRenderFns } from "./filePage.vue?vue&type=template&id=f6b63cae&scoped=true&"
import script from "./filePage.vue?vue&type=script&lang=js&"
export * from "./filePage.vue?vue&type=script&lang=js&"
import style0 from "./filePage.vue?vue&type=style&index=0&id=f6b63cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b63cae",
  null
  
)

export default component.exports